(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dac-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dac-gallery-marquee')) {
    customElements.define('dac-gallery-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.viewport = this.querySelector('.dac-gallery-marquee__viewport');
        this.track = this.querySelector('.dac-gallery-marquee__track');
        this.group = this.querySelector('.dac-gallery-marquee__group');
        this.button = this.querySelector('.dac-gallery-marquee__toggle');
        if (!this.group?.children.length) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.motion.addEventListener('change', () => this.rebuild(), options);
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.button.setAttribute('aria-pressed', String(this.userPaused));
          this.button.setAttribute('aria-label', this.userPaused ? 'Play gallery' : 'Pause gallery');
          this.syncPlayback();
        }, options);
        this.addEventListener('pointerenter', () => {
          this.hovered = this.hasAttribute('data-pause-on-hover');
          this.syncPlayback();
        }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.syncPlayback(); }, options);
        this.addEventListener('focusin', () => { this.focused = this.viewport.contains(document.activeElement); this.syncPlayback(); }, options);
        this.addEventListener('focusout', () => {
          queueMicrotask(() => { this.focused = this.viewport.contains(document.activeElement); this.syncPlayback(); });
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.addEventListener('shopify:block:select', (event) => {
          this.editing = true;
          this.syncPlayback();
          if (event.target instanceof HTMLElement) event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editing = false; this.syncPlayback(); }, options);
        this.resize = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.rebuild());
        });
        this.resize.observe(this.viewport);
        this.resize.observe(this.group);
        this.visibility = new IntersectionObserver(([entry]) => {
          this.nearby = entry.isIntersecting;
          if (this.nearby) this.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
          this.syncPlayback();
        }, { rootMargin: '400px' });
        this.visibility.observe(this);
        this.rebuild();
      }
      rebuild() {
        if (!this.isConnected || !this.group?.children.length) return;
        const distance = this.group.getBoundingClientRect().width;
        const viewportWidth = this.viewport.clientWidth;
        const reduced = this.motion.matches;
        if (!distance || !viewportWidth) return;
        const signature = [distance, viewportWidth, reduced, this.dataset.speed, this.dataset.direction].join(':');
        if (signature === this.signature) return;
        this.signature = signature;
        const progress = this.animation?.effect.getComputedTiming().progress || 0;
        this.animation?.cancel();
        this.animation = null;
        this.track.querySelectorAll('[data-marquee-copy]').forEach(copy => copy.remove());
        this.toggleAttribute('data-static', reduced);
        this.button.hidden = reduced;
        if (reduced) return;
        // Each group includes its trailing gap. Resetting by exactly one group
        // places every copy on the preceding group's pixels without a jump.
        const copies = Math.ceil(viewportWidth / distance) + 1;
        for (let index = 0; index < copies; index++) {
          const copy = this.group.cloneNode(true);
          copy.setAttribute('data-marquee-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach(node => {
            node.removeAttribute('id');
            node.removeAttribute('data-shopify-editor-block');
          });
          copy.querySelectorAll('a, button, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
          if (this.nearby) copy.querySelectorAll('img').forEach(image => { image.loading = 'eager'; });
          this.track.append(copy);
        }
        const speed = Math.max(1, Number(this.dataset.speed) || 20);
        const duration = distance / speed * 1000;
        const frames = [ { transform: 'translate3d(0,0,0)' }, { transform: `translate3d(${-distance}px,0,0)` } ];
        if (this.dataset.direction === 'start-to-end') frames.reverse();
        this.animation = this.track.animate(frames, { duration, iterations: Infinity, easing: 'linear' });
        this.animation.currentTime = progress * duration;
        this.syncPlayback();
      }
      syncPlayback() {
        if (!this.animation) return;
        const paused = this.userPaused || this.hovered || this.focused || this.editing || document.hidden || !this.nearby;
        if (paused) this.animation.pause(); else this.animation.play();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.resize?.disconnect();
        this.visibility?.disconnect();
        this.animation?.cancel();
        cancelAnimationFrame(this.resizeFrame);
        this.signature = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
